export default "__VITE_ASSET__wvc2E3q7__"